import React from "react";
import { PageHero } from "./About";
import { useClinic } from "../context/ClinicContext";

export default function Privacy() {
  const c = useClinic();
  return (
    <div>
      <PageHero eyebrow="Legal" title="Privacy Policy & Terms" subtitle="How we handle your information and the terms of using our website." />
      <section className="py-14 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 prose-sm text-[#334E68] leading-relaxed space-y-6">
          <div>
            <h2 className="text-xl font-bold text-[#0F1E36] mb-2">Privacy Policy</h2>
            <p>Revive Family Clinic & X-Ray Diagnostics is committed to protecting your privacy. Any personal information you share with us — such as your name, contact details and appointment preferences — is used solely to provide and improve our healthcare services. We do not sell or share your personal information with third parties for marketing purposes.</p>
          </div>
          <div>
            <h2 className="text-xl font-bold text-[#0F1E36] mb-2">Appointment Information</h2>
            <p>Details submitted through our appointment form are used to contact you and schedule your visit. Medical records are handled confidentially in line with applicable healthcare regulations.</p>
          </div>
          <div>
            <h2 className="text-xl font-bold text-[#0F1E36] mb-2">Terms & Conditions</h2>
            <p>The content on this website is for general informational purposes and does not replace professional medical advice, diagnosis or treatment. Always consult a qualified healthcare provider regarding any medical concern.</p>
          </div>
          <div>
            <h2 className="text-xl font-bold text-[#0F1E36] mb-2">Contact</h2>
            <p>For any questions about this policy, contact us at <a href={`mailto:${c.email}`} className="text-[#1A75BC] font-semibold">{c.email}</a>.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
